module.exports = __webpack_public_path__ + "static/img/img.feddc52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.jpg
// module id = Rx1w
// module chunks = 3